import {
  vArray,
  vDate,
  vMinValue,
  vNumber,
  vObject,
  vObjectId,
  vOmit,
  vOptional,
  type vOutput,
  vPicklist,
  vPipe,
} from '../validation/index.ts'

export const fuelTableCalculationTypes = ['per-mile', 'percent'] as const
export type FuelTableCalculationType =
  (typeof fuelTableCalculationTypes)[number]

const fuelTableEntrySchema = vObject({
  lowerBoundary: vPipe(vNumber(), vMinValue(0)),
  upperBoundary: vPipe(vNumber(), vMinValue(0)),
  rate: vNumber(),
})

export const fuelTableSchema = vObject({
  _id: vObjectId(),
  accountId: vObjectId(),
  addedById: vObjectId(),
  carrierId: vOptional(vObjectId()),
  createdDate: vDate(),
  type: vPicklist(fuelTableCalculationTypes),
  currency: vPicklist(['usd']),
  rows: vArray(fuelTableEntrySchema),
})

export type FuelTable = vOutput<typeof fuelTableSchema>

export const addFuelTableSchema = vOmit(fuelTableSchema, [
  '_id',
  'accountId',
  'addedById',
  'createdDate',
])

export type AddFuelTableDTO = vOutput<typeof addFuelTableSchema>

export type ParsedFuelTableRow = {
  calculationType?: string
  lowerBoundary?: number
  rate?: number
  upperBoundary?: number
}

export const PERCENT_RATE_MIN = 0

export function isValidPercentRate(rate: number): boolean {
  return rate >= PERCENT_RATE_MIN
}
